import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { strings } from "../../../common/i18n";
import { helpers } from "../../../common/lib";

/**
 *  Hook for user table data and operations
 */

export default () => {
    const { assets, auditAssets } = useSelector((state) => state);

    const [data, setData] = useState([]);

    useEffect(() => {
        const next = auditAssets.data
            .filter(
                (item) =>
                    !item.isAssigned && item.isMandatory && item.isExpected
            )
            .map((item) => {
                const { identifier1, identifier2, type } =
                    helpers.getListItemForId(assets, item.asset);
                return {
                    ...item,
                    identifier1,
                    identifier2,
                    type,
                    isSelected: false
                };
            });
        setData(next);
    }, [assets, auditAssets]);

    /** Check if vin is present in the list use assets from store */
    const vinCheck = (vin) =>
        assets.data.filter((item) => item.identifier1 === vin);

    /** On columns  */
    const columns = [
        {
            accessorKey: "identifier1",
            header: strings("vin")
        },
        {
            accessorKey: "identifier2",
            header: strings("reg")
        },
        {
            accessorKey: "auditLocation",
            header: strings("auditLocation")
        }
    ];

    return {
        columns,
        data,
        vinCheck
    };
};
